"use client";

import { c as _c } from "react/compiler-runtime";
import { useHeaderContext } from "@/contexts/HeaderContext";
import type { ReactNode } from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { SIDEBAR_WIDTHS } from "../../constants/sidebar";
import { SidebarProvider } from "../../hooks/useSidebarState";
import { useLayout } from "../brain/my-stream/layout/LayoutContext";
import SmallScreenHeader from "./SmallScreenHeader";
import WebSidebar from "./sidebar/WebSidebar";
interface Props {
  readonly children: ReactNode;
}
export default function SmallScreenLayout(t0) {
  const $ = _c(22);
  const {
    children
  } = t0;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    registerRef
  } = useLayout();
  const {
    setHeaderRef
  } = useHeaderContext();
  const containerRef = useRef(null);
  let t1;
  if ($[0] !== registerRef || $[1] !== setHeaderRef) {
    t1 = node => {
      registerRef("header", node);
      setHeaderRef(node);
    };
    $[0] = registerRef;
    $[1] = setHeaderRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const headerWrapperRef = t1;
  let t2;
  let t3;
  if ($[3] !== registerRef || $[4] !== setHeaderRef) {
    t2 = () => () => {
      registerRef("header", null);
      setHeaderRef(null);
    };
    t3 = [registerRef, setHeaderRef];
    $[3] = registerRef;
    $[4] = setHeaderRef;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsMenuOpen(_temp);
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const toggleMenu = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsMenuOpen(false);
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const closeMenu = t5;
  let t6;
  if ($[9] !== isMenuOpen) {
    t6 = <SmallScreenHeader onMenuToggle={toggleMenu} isMenuOpen={isMenuOpen} />;
    $[9] = isMenuOpen;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== headerWrapperRef || $[12] !== t6) {
    t7 = <div ref={headerWrapperRef}>{t6}</div>;
    $[11] = headerWrapperRef;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isMenuOpen) {
    t8 = <div className="tailwind-scope"><WebSidebar isCollapsed={false} onToggle={toggleMenu} isMobile={true} isOffcanvasOpen={isMenuOpen} onCloseOffcanvas={closeMenu} sidebarWidth={SIDEBAR_WIDTHS.EXPANDED} /></div>;
    $[14] = isMenuOpen;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== children) {
    t9 = <main className="tw-transition-opacity tw-duration-300">{children}</main>;
    $[16] = children;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <SidebarProvider><div ref={containerRef} className="tw-bg-black tw-overflow-auto">{t7}{t8}{t9}</div></SidebarProvider>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp(prev) {
  return !prev;
}